'use memo';

import Icon from '@/components/Icon/Icon';
import { Text } from '@/components/Typography';

type AiChatEmptyStateProps = {
  title: string;
  description: string;
};

export function AiChatEmptyState({
  title,
  description,
}: AiChatEmptyStateProps) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 px-6 text-center">
      <div className="rounded-full bg-primary-muted-fill p-3">
        <Icon
          iconName="BotMessageSquareIcon"
          className="text-primary-on-muted-fill"
          inheritColor
        />
      </div>
      <Text variant="label" className="text-neutral-on-fill">
        {title}
      </Text>
      <Text variant="pSmall" className="text-neutral-muted-on-fill">
        {description}
      </Text>
    </div>
  );
}
